// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../addDays/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var addDays = convertToFP(fn, 2);
export default addDays;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/addDays/index.js
// module id = 810
// module chunks = 0